import Modal from 'react-modal';
import React from "react";
import { ReactComponent as Close } from '../../../../assets/images/close.svg';
import { Oval } from 'react-loader-spinner';

import './CancelInvoiceModal.scss'

const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: "#FFFFFF"
    },
  };

export interface CancelInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  invoiceType?: string;
  invoiceAmount?: number;
}

export const CancelInvoiceModal = (props: CancelInvoiceModalProps) => {
    const { isOpen, onClose, onConfirm, loading, invoiceType, invoiceAmount } = props;

    return (
      <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
        <div className='cancel-invoice-modal-container'>
          <Close className='close-button' onClick={onClose}/>

          <div className='title'>Cancel Invoice</div>
          <div className='message'>Are you sure you want to cancel this invoice? This action cannot be undone.</div>

          {(invoiceType || invoiceAmount !== undefined) && (
            <div className='invoice-details'>
              {invoiceType && (
                <div className='detail-row'>
                  <span className='detail-label'>Type:</span>
                  <span className='detail-value'>{invoiceType}</span>
                </div>
              )}
              {invoiceAmount !== undefined && (
                <div className='detail-row'>
                  <span className='detail-label'>Amount:</span>
                  <span className='detail-value'>${invoiceAmount}</span>
                </div>
              )}
            </div>
          )}

          <div className='buttons-container'>
            <button type='button' className='button secondary-button' disabled={loading} onClick={onClose}>
              No, Keep It
            </button>
            <button type='button' className='button' disabled={loading} onClick={onConfirm}>
              Yes, Cancel Invoice
              {loading && <div style={{ marginLeft: 8}}><Oval color="#131313" height={20} width={20} secondaryColor="#FBD20A"/></div>}
            </button>
          </div>
        </div>
      </Modal>
    );
}
